import React, { Component } from 'react'
import { Button, Modal, Select } from 'advenio-components'
import styled from 'styled-components'
import PropTypes from 'prop-types' //eslint-disable-line
import R from 'ramda'
import ProfilePicture from '../ChildrenList/ProfilePicture'
import ExtraCharge from './ExtraCharge'
import HourModal from './HourModal'
import { Form } from 'formsy-react'
import {
  ChildrenDiv,
  ChildrenContainer,
  ProfileDiv,
  Container,
  Continue,
  SelectAllContainer,
  Div,
  IconsDiv,
  ActionButton,
  Img,
  ProfileDivOverlay,
  InfoDiv,
  InfoDivOverlay,
  NameDiv,
  Charge,
  ChildrenInfoContainer,
  ChargeDiv,
} from './SelectKids.styles'

const LastStepButton = styled(Button)`
  flex: 1;
`
const SelectContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 20px;
`
class SelectKids extends Component {
  constructor(props) {
    super(props)
    let newClassrooms = []
    const { classrooms, children, group } = this.props
    const initialState = children
      .filter(
        student =>
          student.checkin.status === 'Advenio' && student.checkin.is_virtual_center !== true,
      )
      .map(student => ({ ...student, selected: false, consumable_ids: [], extras: [] }))
    if (group) {
      newClassrooms = classrooms
        .filter(room => room.type === 'Normal')
        .map(room => ({ ...room, label: room.name, value: room.id }))
      const sickRooms = classrooms
        .filter(room => room.type === 'Sick Room')
        .map(room => ({ ...room, label: room.name, value: room.id }))
      newClassrooms = [...newClassrooms, ...sickRooms]
    }
    const clonedChildren = R.clone(initialState)
    this.state = {
      childrenToRender: this.childrenToSelect(clonedChildren),
      isComplete: false,
      childrenSelected: 0,
      open: false,
      child: [],
      allSelected: false,
      hourModal: false,
      hour: 0,
      rooms: newClassrooms,
    }
  }

  onClick = (e) => {
    const id = e.target.id
    const aux = []
    let count = 0
    const newState = { ...this.state }
    for (let i = 0; i < newState.childrenToRender.length; i++) {
      if (newState.childrenToRender[i].id == id) {
        newState.childrenToRender[i].selected = !newState.childrenToRender[i].selected
      }
      if (newState.childrenToRender[i].selected) {
        aux.push(true)
        count++
      } else {
        aux.push(false)
      }
    }

    newState.isComplete = aux.indexOf(true) >= 0
    newState.childrenSelected = count
    newState.allSelected = count === this.state.childrenToRender.length
    this.setState(newState)
  }

  send = (info) => {
    const infoToSend = []
    for (let i = 0; i < this.state.childrenToRender.length; i++) {
      if (this.state.childrenToRender[i].selected) {
        infoToSend.push({
          id: this.state.childrenToRender[i].id,
          consumable_ids: this.state.childrenToRender[i].extras,
          checkin_id: this.state.childrenToRender[i].checkin.id,
        })
      }
    }
    this.setState({ childrenToAddActivity: infoToSend, hour: info.hour }, () => this.saveActivity())
  }

  childrenToSelect = (children) => {
    const newChildren = []
    if (this.props.oldView == 'Photo') {
      return children
    }
    for (let i = 0; i < children.length; i++) {
      if (children[i].latest_activities.length > 0) {
        if (children[i].latest_activities[0].finished_at !== null) {
          newChildren.push(children[i])
        }
      } else {
        newChildren.push(children[i])
      }
    }
    return newChildren
  }

  saveActivity = () => {
    const params = {
      category_id: this.props.info.category_id,
      type_id: this.props.info.type_id,
      total_drink: this.props.info.drink,
      total_eat: this.props.info.eat,
      students: this.state.childrenToAddActivity,
      time: this.state.hour,
    }
    this.props.postGroupActivity(params)
    this.props.closeModal()
  }

  selectAll = () => {
    const newState = { ...this.state }
    const count = newState.childrenToRender.length
    for (let i = 0; i < newState.childrenToRender.length; i++) {
      newState.childrenToRender[i].selected = !this.state.allSelected
    }
    newState.childrenSelected = !this.state.allSelected ? count : 0
    newState.allSelected = !this.state.allSelected
    newState.isComplete = !this.state.allSelected
    this.setState(newState)
  }

  openCharge = (event) => {
    const [child] = this.state.childrenToRender.filter(children => children.id == event.target.id)
    this.setState({ open: true, child })
  }

  closeModal = () => {
    this.setState({ open: false })
  }

  extras = (extras, id) => {
    const toAdd = []
    const newState = { ...this.state }
    for (let i = 0; i < extras.length; i++) {
      toAdd.push(extras[i].id)
    }
    for (let i = 0; i < newState.childrenToRender.length; i++) {
      if (newState.childrenToRender[i].id == id) {
        newState.childrenToRender[i].consumable_ids = extras
        newState.childrenToRender[i].extras = toAdd
      }
    }
    this.setState(newState)
  }

  toggleHourModal = (e) => {
    this.setState({ hourModal: !this.state.hourModal })
  }

  selectRoom = (model) => {
    let kidsToRender = []
    const roomSelected = this.props.classrooms.find(room => room.id == model.classroom)
    const roomToRender = R.clone(roomSelected)
    for (let i = 0; i < roomToRender.students.length; i++) {
      roomToRender.students[i].selected = false
      roomToRender.students[i].consumable_ids = []
      roomToRender.students[i].extras = []
    }
    if (this.props.user.role === 'Teacher') {
      kidsToRender = roomToRender.students.filter(
        kid => kid.checkin.id !== null && kid.checkin.status !== "Nurse's Room",
      )
    } else {
      kidsToRender = roomToRender.students.filter(kid => kid.checkin.id !== null)
    }
    this.setState({ childrenToRender: this.childrenToSelect(kidsToRender) })
  }

  render() {
    const { isComplete } = this.state
    const { user } = this.props
    return (
      <Container>
        <SelectAllContainer>
          <Div>
            <span>{`${this.state.childrenSelected} Seleccionados    `}</span>
          </Div>
          <Div>
            <span style={{ color: '#3E72D7', cursor: 'pointer' }} onClick={this.selectAll}>
              {this.state.allSelected ? 'Deseleccionar Todos' : 'Seleccionar Todos'}
            </span>
          </Div>
        </SelectAllContainer>
        {this.props.group ? (
          <Form onChange={this.selectRoom}>
            {user.role !== 'Teacher' && (
              <SelectContainer>
                <Select
                  name="classroom"
                  label="Selecciona un salon"
                  value={this.state.rooms.length > 0 ? this.state.rooms[0].value : 1}
                  options={this.state.rooms}
                />
              </SelectContainer>
            )}
          </Form>
        ) : (
          ''
        )}
        <ChildrenContainer>
          {this.state.childrenToRender.map((currentValue, index, array) => (
            <ChildrenInfoContainer key={index}>
              <ChildrenDiv type={currentValue.type}>
                <IconsDiv>
                  <ActionButton>
                    <Img
                      src={currentValue.selected ? '/assets/checked.svg' : '/assets/emptyCheck.svg'}
                      alt="type"
                      id={currentValue.id}
                      onClick={this.onClick}
                    />
                  </ActionButton>
                </IconsDiv>
                <ProfileDiv>
                  <ProfileDivOverlay id={currentValue.id} />
                  <ProfilePicture
                    profile_image={currentValue.profile_image}
                    type={currentValue.checkin.status}
                  />
                </ProfileDiv>
                <InfoDiv>
                  <InfoDivOverlay id={currentValue.id} />
                  <NameDiv>
                    <span>{`${currentValue.first_name} ${currentValue.last_name_paternal}`}</span>
                  </NameDiv>
                </InfoDiv>
                <IconsDiv>
                  <ActionButton>
                    <Img
                      src="/assets/extracharge.svg"
                      alt="type"
                      id={currentValue.id}
                      onClick={this.openCharge}
                    />
                  </ActionButton>
                </IconsDiv>
              </ChildrenDiv>
              {currentValue.consumable_ids.length > 0 ? (
                <ChargeDiv>
                  <span style={{ color: '#4A90E2', marginLeft: '30px' }}>Cargos extra:</span>
                  {currentValue.consumable_ids.map((item, index) => (
                    <Charge key={index}>{`- ${item.consumable}`}</Charge>
                  ))}
                </ChargeDiv>
              ) : (
                ''
              )}
            </ChildrenInfoContainer>
          ))}
        </ChildrenContainer>
        <Continue>
          <LastStepButton
            small
            primary={isComplete}
            disabled={!isComplete}
            onClick={this.toggleHourModal}
          >
            Continuar
          </LastStepButton>
        </Continue>
        <Modal isOpened={this.state.open} full onClose={this.closeModal}>
          <ExtraCharge
            child={this.state.child}
            closeModal={this.closeModal}
            group={this.props.group}
            setExtraData={this.props.setExtraData}
            info={this.props.info}
            goToView={this.props.goToView}
            extras={this.extras}
          />
        </Modal>
        <HourModal open={this.state.hourModal} onClose={this.toggleHourModal} onSend={this.send} />
      </Container>
    )
  }
}

SelectKids.propTypes = {
  goToView: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  setExtraData: PropTypes.func.isRequired,
  info: PropTypes.object,
}

SelectKids.defaultProps = {
  info: {},
}

export default SelectKids



// WEBPACK FOOTER //
// ./src/Components/Activity/SelectKids.jsx